module.exports = __webpack_public_path__ + "static/media/PDF.ee966261.png";